import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { NotificacoesProvider } from './contexts/NotificacoesContext';
import ErrorBoundary from './components/ErrorBoundary';
import Login from './pages/Login';
import Cadastro from './pages/Cadastro';
import AdminDashboard from './pages/AdminDashboard';
import AdminUsuarios from './pages/AdminUsuarios';
import AdminEstacoesNovo from './pages/AdminEstacoesNovo';
import AdminSessoesEspera from './pages/AdminSessoesEspera';
import AdminSessaoPage from './pages/AdminSessaoPage';
import AdminResumos from './pages/AdminResumos';
import MedicoDashboard from './pages/MedicoDashboard';
import PresentationScreen from './pages/PresentationScreen';
import SessaoPage from './pages/SessaoPage';
import UsuarioResumosNovo from './pages/UsuarioResumosNovo';
import VisualizarResumo from './pages/VisualizarResumo';
import UsuarioSuporte from './pages/UsuarioSuporte';
import AdminSuporteNovo from './pages/AdminSuporteNovo';
import MedicoDesempenho from './pages/MedicoDesempenho'; // NEW
import AtorDashboard from './pages/AtorDashboard';
import EstacoesEspecialidade from './pages/EstacoesEspecialidade';
import { Toaster } from './components/ui/sonner';
import './App.css';

const PrivateRoute = ({ children, allowedRoles }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#191919]">
        <div className="text-white text-xl">Carregando...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (allowedRoles && !allowedRoles.includes(user.papel)) {
    return <Navigate to="/login" />;
  }

  return children;
};

function App() {
  const handleConviteNovo = (data) => {
    console.log('[App] handleConviteNovo chamado, disparando CustomEvent:', data);
    // Dispatch custom event that PresentationScreen will listen to
    window.dispatchEvent(new CustomEvent('convite_novo_ws', { detail: data }));
    console.log('[App] CustomEvent convite_novo_ws disparado');
  };

  return (
    <ErrorBoundary>
      <AuthProvider>
        <NotificacoesProvider onConviteNovo={handleConviteNovo}>
          <BrowserRouter>
          <Routes>
          <Route path="/" element={<Navigate to="/login" />} />
          <Route path="/login" element={<Login />} />
          <Route path="/cadastro" element={<Cadastro />} />
          
          {/* Admin Routes */}
          <Route
            path="/admin"
            element={
              <PrivateRoute allowedRoles={['admin']}>
                <AdminDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/usuarios"
            element={
              <PrivateRoute allowedRoles={['admin']}>
                <AdminUsuarios />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/estacoes"
            element={
              <PrivateRoute allowedRoles={['admin']}>
                <AdminEstacoesNovo />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/sessoes/espera"
            element={
              <PrivateRoute allowedRoles={['admin']}>
                <AdminSessoesEspera />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/sessao/:sessaoId"
            element={
              <PrivateRoute allowedRoles={['admin']}>
                <AdminSessaoPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/suporte"
            element={
              <PrivateRoute allowedRoles={['admin']}>
                <AdminSuporteNovo />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin/resumos"
            element={
              <PrivateRoute allowedRoles={['admin']}>
                <AdminResumos />
              </PrivateRoute>
            }
          />
          
          {/* Medico Routes */}
          <Route
            path="/usuario"
            element={
              <PrivateRoute allowedRoles={['medico']}>
                <PresentationScreen />
              </PrivateRoute>
            }
          />
          <Route
            path="/usuario/sessao/:sessaoId"
            element={
              <PrivateRoute allowedRoles={['medico']}>
                <SessaoPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/usuario/resumos"
            element={
              <PrivateRoute allowedRoles={['medico']}>
                <UsuarioResumosNovo />
              </PrivateRoute>
            }
          />
          {/* NEW: Desempenho Route */}
          <Route
            path="/medico/desempenho"
            element={
              <PrivateRoute allowedRoles={['medico']}>
                <MedicoDesempenho />
              </PrivateRoute>
            }
          />
          <Route
            path="/usuario/resumos/:id"
            element={
              <PrivateRoute allowedRoles={['medico']}>
                <VisualizarResumo />
              </PrivateRoute>
            }
          />
          <Route
            path="/usuario/suporte"
            element={
              <PrivateRoute allowedRoles={['medico']}>
                <UsuarioSuporte />
              </PrivateRoute>
            }
          />
          <Route
            path="/usuario/especialidade/:especialidadeId"
            element={
              <PrivateRoute allowedRoles={['medico']}>
                <EstacoesEspecialidade />
              </PrivateRoute>
            }
          />
          
          {/* Ator Routes */}
          <Route
            path="/ator"
            element={
              <PrivateRoute allowedRoles={['ator']}>
                <AtorDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/ator/sessoes/espera"
            element={
              <PrivateRoute allowedRoles={['ator']}>
                <AdminSessoesEspera />
              </PrivateRoute>
            }
          />
          <Route
            path="/ator/sessao/:sessaoId"
            element={
              <PrivateRoute allowedRoles={['ator']}>
                <AdminSessaoPage />
              </PrivateRoute>
            }
          />
        </Routes>
        <Toaster position="top-right" />
      </BrowserRouter>
        </NotificacoesProvider>
    </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;